/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step6Inputs */

const en_dr_room_step6 = /** @type {(inputs: Dr_Room_Step6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulate`)
};

const id_dr_room_step6 = /** @type {(inputs: Dr_Room_Step6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumuskan`)
};

/**
* | output |
* | --- |
* | "Formulate" |
*
* @param {Dr_Room_Step6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step6 = /** @type {((inputs?: Dr_Room_Step6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step6(inputs)
	return en_dr_room_step6(inputs)
});